import { registerComponent, scrollLock, triggerEvent } from "helpers";

registerComponent(
  "wyatt-modal",
  class WyattModal extends HTMLElement {
    constructor() {
      super();

      this.openButton = this.querySelector("[data-modal-open]");
      this.dialog = this.getModal();
      this.wrapper = this.dialog.querySelector("[data-modal-wrapper]");

      this.openButton.addEventListener("click", this.open.bind(this));

      this.handleClickOutside();

      this.dialog.addEventListener("close", this.close.bind(this));
    }

    connectedCallback() {
      document.querySelector("body").append(this.dialog);
    }

    disconnectedCallback() {
      this.dialog.remove();
    }

    open() {
      this.dialog.showModal();
      scrollLock.enable();
      triggerEvent(this.dialog, "modalOpen");
    }

    close() {
      scrollLock.disable();
      triggerEvent(this.dialog, "modalClose");
    }

    handleClickOutside() {
      this.dialog.addEventListener("click", () => {
        this.dialog.close();
      });
      this.wrapper.addEventListener("click", (event) => {
        event.stopPropagation();
      });
    }

    getModal() {
      return (
        this.querySelector("[data-modal]") ||
        document.querySelector(this.openButton.dataset.modalOpen)
      );
    }
  }
);
